const CLEAR_BUTTON_EVENT_TYPES = new Set(["click", "mousedown"]);

export const isAutocompleteInputClear = (reason, event) =>
  reason === "clear" && !CLEAR_BUTTON_EVENT_TYPES.has(event?.type);
